import React from "react";
import "./contact.css";
import emailjs from 'emailjs-com';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Contact() {


  const send_email =(e)=>{
    e.preventDefault();
   console.log("e>>>>>",e.target.name);
 
   toast.loading("Loading ");
   emailjs.sendForm('service_9mzssjg', 'template_1o0onlr', e.target, '92u7uUh7h7w1zjR6G')
   .then((result) => {
    toast.dismiss()

       console.log(result.text);
       toast.success("Email send successfully", {
        autoClose: 2000
                // autoClose: false

      })
   }, (error) => {
       console.log(error.text);
       alert(error.text)
   });
  }


  return (
    <>
      <div className="site-footer">
        <div>
          <div className="contact-form">
            <form onSubmit={send_email}>
              <label htmlFor="#">
                <span>Do you want to know us?</span>
                <span>Contact us now</span>
              </label>
              <div className="control">
                <input type="text" name="to_name" placeholder="Enter Your Email" />
                <input type="text" name="message" placeholder="Enter Your Message" />
                <button  className="ctnbtn" type="submit">
                  Contact
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
